/* eslint-disable @typescript-eslint/camelcase */
export const SYSTEM_CODE = {
  DIRECT_COMMON: 'direct_common',
  YANDEX_NETWORK: 'yandex_network',
  TARGET_GROUP: 'target_group',
  AVITOADS: 'avitoAds',
  OZON: 'ozon',
  WILDBERRIES: 'wildberries',
  YASPRAVOCHNIK: 'yaspravochnik',
  SBER_ADS: 'sber_ads',
  GNEZDO: 'gnezdo',
  OOHDESK_DSP: 'oohdesk_dsp',
  TWO_GIS: 'two_gis',
  T_BANK: 't_bank',
  HYBRID_PLATFORM: 'hybrid_platform',
  URBAN_ADS: 'urban_ads',
  WOW_BLOGGER: 'wow_blogger',
  TELEGA_IN: 'telega_in',
  GETBLOGGER: 'getblogger',
  YADZEN: 'yadzen',
  VK_ADBLOGGER: 'vk_adblogger',
  AVITO: 'avito',
  YANAVIGATOR: 'yanavigator',
  GET_RADIO: 'get_radio',
  CALLTOUCH: 'calltouch',
  TELEGRAMADS: 'telegramAds',
  GOOGLE_INTERNAL: 'google_internal',
  TIKTOK_ADS: 'tiktok_ads',
  MARKETOLOG_PRO: 'marketolog_pro',
  SEO_WIZARD: 'seo_wizard',
  SAMBA: 'samba',
  I_DIGITAL: 'i_digital'
} as const

export const SYSTEM_ORDER = Object.values(SYSTEM_CODE)

export const NO_REWARD_SYSTEM_LIST: Array<string> = [
  SYSTEM_CODE.GOOGLE_INTERNAL,
  SYSTEM_CODE.TIKTOK_ADS,
  SYSTEM_CODE.I_DIGITAL,
  SYSTEM_CODE.SEO_WIZARD,
  SYSTEM_CODE.MARKETOLOG_PRO,
  SYSTEM_CODE.SAMBA
]
// Значения для отображения
export const SYSTEM_SINGLE_RATES: Record<string, string> = {
  [SYSTEM_CODE.DIRECT_COMMON]: '6',
  [SYSTEM_CODE.YANDEX_NETWORK]: '9',
  [SYSTEM_CODE.TARGET_GROUP]: '15',
  [SYSTEM_CODE.AVITOADS]: '20',
  [SYSTEM_CODE.OZON]: '20',
  [SYSTEM_CODE.WILDBERRIES]: '15',
  [SYSTEM_CODE.YASPRAVOCHNIK]: '10',
  [SYSTEM_CODE.WOW_BLOGGER]: '6',
  [SYSTEM_CODE.SBER_ADS]: '10',
  [SYSTEM_CODE.GNEZDO]: '10',
  [SYSTEM_CODE.OOHDESK_DSP]: '20',
  [SYSTEM_CODE.TWO_GIS]: '15',
  [SYSTEM_CODE.T_BANK]: '11',
  [SYSTEM_CODE.HYBRID_PLATFORM]: '13',
  [SYSTEM_CODE.URBAN_ADS]: '8',
  [SYSTEM_CODE.TELEGA_IN]: '4',
  [SYSTEM_CODE.GETBLOGGER]: '5',
  [SYSTEM_CODE.YADZEN]: '8',
  [SYSTEM_CODE.VK_ADBLOGGER]: '8',
  [SYSTEM_CODE.AVITO]: '8',
  [SYSTEM_CODE.YANAVIGATOR]: '8',
  [SYSTEM_CODE.GET_RADIO]: '8',
  [SYSTEM_CODE.CALLTOUCH]: '8',
  [SYSTEM_CODE.TELEGRAMADS]: '5'
}

// Значения для расчета вознаграждения
export const SYSTEM_SINGLE_RATES_VALUES: Record<string, string> = {
  ...SYSTEM_SINGLE_RATES,
  [SYSTEM_CODE.OZON]: '20'
}

// Значения для отображения
export const SYSTEM_TIER_RATES: Record<string, Array<string>> = {
  [SYSTEM_CODE.DIRECT_COMMON]: ['4', '4.5', '5'],
  [SYSTEM_CODE.YANDEX_NETWORK]: ['16', '16', '16'],
  [SYSTEM_CODE.TARGET_GROUP]: ['6', '8', '9'],
  [SYSTEM_CODE.AVITOADS]: ['20', '20', '20'],
  [SYSTEM_CODE.OZON]: ['10', '15', '20'],
  [SYSTEM_CODE.WILDBERRIES]: ['7', '10', '15'],
  [SYSTEM_CODE.YASPRAVOCHNIK]: ['9', '10', '10'],
  [SYSTEM_CODE.WOW_BLOGGER]: ['4', '5', '6'],
  [SYSTEM_CODE.SBER_ADS]: ['8', '10', '10'],
  [SYSTEM_CODE.GNEZDO]: ['8', '10', '10'],
  [SYSTEM_CODE.OOHDESK_DSP]: ['10', '15', '20'],
  [SYSTEM_CODE.TWO_GIS]: ['10', '12', '15'],
  [SYSTEM_CODE.T_BANK]: ['4', '7', '11'],
  [SYSTEM_CODE.HYBRID_PLATFORM]: ['5', '8', '13'],
  [SYSTEM_CODE.URBAN_ADS]: ['3', '5', '8'],
  [SYSTEM_CODE.TELEGA_IN]: ['2', '3', '4'],
  [SYSTEM_CODE.GETBLOGGER]: ['2', '3', '5'],
  [SYSTEM_CODE.YADZEN]: ['7', '8', '8'],
  [SYSTEM_CODE.VK_ADBLOGGER]: ['7', '8', '8'],
  [SYSTEM_CODE.AVITO]: ['7', '8', '8'],
  [SYSTEM_CODE.YANAVIGATOR]: ['7', '8', '8'],
  [SYSTEM_CODE.GET_RADIO]: ['7', '8', '8'],
  [SYSTEM_CODE.CALLTOUCH]: ['7', '8', '8'],
  [SYSTEM_CODE.TELEGRAMADS]: ['2', '4', '5']
}

// Значения для расчета вознаграждения
export const SYSTEM_TIER_RATES_VALUES: Record<string, Array<string>> = {
  ...SYSTEM_TIER_RATES,
  [SYSTEM_CODE.OZON]: ['10', '15', '20']
}

export const UPDATED_SYSTEM_NAMES_ACTIVE: Record<string, string> = {
  [SYSTEM_CODE.DIRECT_COMMON]: 'Директ',
  [SYSTEM_CODE.YANAVIGATOR]: 'Яндекс Навигатор',
  [SYSTEM_CODE.YADZEN]: 'ПромоСтраницы',
  [SYSTEM_CODE.GET_RADIO]: 'GetRadio',
  [SYSTEM_CODE.YASPRAVOCHNIK]: 'Яндекс Бизнес',
  [SYSTEM_CODE.TARGET_GROUP]: 'Таргет'
}

export const UPDATED_SYSTEM_NAMES_NEW: Record<string, string> = {
  ...UPDATED_SYSTEM_NAMES_ACTIVE,
  [SYSTEM_CODE.DIRECT_COMMON]: 'Директ • Поиск',
  [SYSTEM_CODE.YANDEX_NETWORK]: 'Директ • РСЯ'
}

export const SYSTEMS_BY_DEFAULT_NEW = [
  SYSTEM_CODE.DIRECT_COMMON,
  SYSTEM_CODE.YANDEX_NETWORK,
  SYSTEM_CODE.TARGET_GROUP
]

export const SYSTEMS_BY_DEFAULT_ACTIVE = [
  SYSTEM_CODE.DIRECT_COMMON,
  SYSTEM_CODE.TARGET_GROUP,
  SYSTEM_CODE.AVITOADS
]

export const SYSTEMS_BY_DEFAULT_TURNOVERS: Record<string, number> = {
  [SYSTEM_CODE.DIRECT_COMMON]: 0,
  [SYSTEM_CODE.TELEGRAMADS]: 0
}

export const SYSTEM_ICON: Record<string, string> = {
  [SYSTEM_CODE.DIRECT_COMMON]: 'directIcon',
  [SYSTEM_CODE.I_DIGITAL]: 'iDigitalIcon',
  [SYSTEM_CODE.SEO_WIZARD]: 'seowizardIcon',
  [SYSTEM_CODE.YANDEX_NETWORK]: 'directIcon',
  [SYSTEM_CODE.GOOGLE_INTERNAL]: 'googleAdsIcon',
  [SYSTEM_CODE.TARGET_GROUP]: 'targetIcon',
  [SYSTEM_CODE.TIKTOK_ADS]: 'tiktokIcon',
  [SYSTEM_CODE.AVITO]: 'avitoIcon',
  [SYSTEM_CODE.YADZEN]: 'promoIcon',
  [SYSTEM_CODE.YANAVIGATOR]: 'navigatorIcon',
  [SYSTEM_CODE.YASPRAVOCHNIK]: 'yandexBussinessIcon',
  [SYSTEM_CODE.CALLTOUCH]: 'calltouchIcon',
  [SYSTEM_CODE.GET_RADIO]: 'getRadioIcon',
  [SYSTEM_CODE.TELEGA_IN]: 'telegaInIcon',
  [SYSTEM_CODE.TELEGRAMADS]: 'tgAdsIcon',
  [SYSTEM_CODE.WOW_BLOGGER]: 'wowBloggerIcon',
  [SYSTEM_CODE.TWO_GIS]: 'twoGisIcon',
  [SYSTEM_CODE.OOHDESK_DSP]: 'oohdeskIcon',
  [SYSTEM_CODE.MARKETOLOG_PRO]: 'mtsIcon',
  [SYSTEM_CODE.VK_ADBLOGGER]: 'posevyIcon',
  [SYSTEM_CODE.SBER_ADS]: 'sberIcon',
  [SYSTEM_CODE.AVITOADS]: 'avitoIcon',
  [SYSTEM_CODE.GNEZDO]: 'gnezdoIcon',
  [SYSTEM_CODE.WILDBERRIES]: 'wbIcon',
  [SYSTEM_CODE.OZON]: 'ozonIcon',
  [SYSTEM_CODE.SAMBA]: 'sambaIcon',
  [SYSTEM_CODE.T_BANK]: 'tBankIcon',
  [SYSTEM_CODE.HYBRID_PLATFORM]: 'hybridIcon',
  [SYSTEM_CODE.URBAN_ADS]: 'urbanIcon',
  [SYSTEM_CODE.GETBLOGGER]: 'getBloggerIcon'
} as const
